import React, {CSSProperties} from 'react'

import {ensureFeedbackStyles, spinnerAnimation, spinnerStyle} from './styles.js'

ensureFeedbackStyles()

interface SpinnerProps {
    style?: CSSProperties
    /** Colour of the ring, dark grey by default */
    color?: string
}

/** A rotating ring that shows something is loading (role status, read as 'Laden'). */
export default function Spinner({style, color = spinnerStyle.color}: SpinnerProps) {
    const defaultStyle: CSSProperties = {
        flexShrink: 0,
        zIndex: spinnerStyle.zIndex,
        borderRadius: '100%',
        border: `${spinnerStyle.borderWidth}px solid ${color}`,
        borderBottomColor: 'transparent',
        opacity: spinnerStyle.opacity,
        height: spinnerStyle.size,
        width: spinnerStyle.size,
        background: 'transparent',
        display: 'inline-block',
        animation: `${spinnerAnimation} ${spinnerStyle.duration} 0s linear infinite`,
        ...style
    }

    return <div role='status' aria-label='Laden' style={defaultStyle} />
}
